import { createSelector } from 'reselect';

const data = (state) => state.reportTemplatesData;

export const selectFilterData = () => createSelector([data], (state) => state.filter);

export const selectReportTypesData = () => createSelector([data], (state) => state.reportTypes);
